// ── Bundled offline lessons (pre-generated) ──────────────────────────────────
// This file is populated by: ANTHROPIC_API_KEY=sk-ant-... node scripts/generateLessons.js
let bundledLessons = {};
try {
  // eslint-disable-next-line
  bundledLessons = require('./data/lessons.json');
} catch (_) {
  // lessons.json doesn't exist yet — will fall back to live API
}

export function getApiKey() {
  return sessionStorage.getItem('pp_api_key') || '';
}
export function setApiKey(key) {
  sessionStorage.setItem('pp_api_key', key);
}
export function isOnline() {
  return typeof navigator !== 'undefined' ? navigator.onLine : true;
}
export function buildHeaders() {
  const key = getApiKey();
  const headers = {
    'Content-Type': 'application/json',
    'anthropic-version': '2023-06-01',
    'anthropic-dangerous-direct-browser-access': 'true',
  };
  if (key) headers['x-api-key'] = key;
  return headers;
}
export function safeParseJSON(str) {
  try { return JSON.parse(str); } catch (_) {}
  let s = str.trim();
  s = s.replace(/,\s*"[^"]*$/, '');
  s = s.replace(/:\s*"[^"]*$/, '');
  s = s.replace(/,\s*\{[^}]*$/, '');
  s = s.replace(/,\s*\[[^\]]*$/, '');
  const opens = (s.match(/\[/g)||[]).length - (s.match(/\]/g)||[]).length;
  const openb = (s.match(/\{/g)||[]).length - (s.match(/\}/g)||[]).length;
  for (let i=0;i<opens;i++) s+=']';
  for (let i=0;i<openb;i++) s+='}';
  return JSON.parse(s);
}

// Lesson fetcher: bundled JSON first, then live API
export async function fetchLesson(topicLabel, subtopic, topicKey) {
  const cacheKey = `${topicKey}::${subtopic}`;
  if (bundledLessons[cacheKey]) {
    // Preserve original _source (e.g. 'phak_ch3') if present, else mark as bundled
    const lesson = bundledLessons[cacheKey];
    return { ...lesson, _source: lesson._source || 'bundled' };
  }
  if (!isOnline()) {
    throw new Error('You are offline and this lesson has not been pre-generated yet.');
  }
  const prompt = `You are a private pilot ground school instructor. Generate a lesson for student pilots.

Topic Module: ${topicLabel}
Lesson Title: ${subtopic}

Return ONLY valid JSON (no markdown, no backticks):
{
  "title": "Lesson title",
  "module": "Module name",
  "duration": "~X min read",
  "sections": [
    {
      "heading": "Section heading",
      "content": "2-3 sentence explanation using <strong> for key terms.",
      "callout": { "type": "info|warning|tip|formula", "text": "One concise callout line." },
      "diagram": { "label": "DIAGRAM: Title", "art": "5-8 line ASCII diagram" }
    }
  ],
  "checkpoint": { "title": "What you should know", "points": ["Takeaway 1","Takeaway 2","Takeaway 3"] },
  "glossary": [{ "term": "TERM", "def": "Short definition." }],
  "quiz": [{ "category": "MODULE // SUBTOPIC", "question": "Question?", "options": ["A","B","C","D"], "correct": 0, "explanation": "Explanation with <strong>key term</strong>." }]
}
Rules: exactly 3 sections each with diagram, exactly 5 glossary terms, exactly 4 quiz questions. Accurate to FAA standards.`;

  const res = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ model: 'claude-haiku-4-5-20251001', max_tokens: 4000, messages: [{ role: 'user', content: prompt }] }),
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  const data = await res.json();
  const text = data.content.map(b => b.text||'').join('');
  return safeParseJSON(text.replace(/```json|```/g,'').trim());
}

export async function fetchQuizBatch(topic, previousQuestions = []) {
  if (!isOnline()) throw new Error('Practice quiz requires an internet connection.');
  const avoid = previousQuestions.slice(-20).map(q=>q.question).join('\n- ');
  const avoidNote = avoid ? `\n\nDo NOT repeat:\n- ${avoid}` : '';
  const prompt = `You are a private pilot ground school instructor creating FAA PAR exam questions.
Generate exactly 5 multiple-choice questions about: ${topic}
Each question: real FAA content, 4 options, vary difficulty.${avoidNote}
Respond ONLY with a valid JSON array (no markdown):
[{"category":"TOPIC // SUBTOPIC","question":"...?","options":["A","B","C","D"],"correct":0,"explanation":"Why correct. Use <strong> for key terms."}]`;
  const res = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ model: 'claude-haiku-4-5-20251001', max_tokens: 4000, messages: [{ role: 'user', content: prompt }] }),
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  const data = await res.json();
  const text = data.content.map(b => b.text||'').join('');
  return safeParseJSON(text.replace(/```json|```/g,'').trim());
}
